import marmoreioMenu from './marmoreio';

const menusByTenant = {
  marmoreio: marmoreioMenu,
};

export const getMenuForTenant = (tenantId) => {
  if (!tenantId || !menusByTenant[tenantId]) {
    return null;
  }
  return menusByTenant[tenantId];
};
